import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { ToastService } from 'src/app/services/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  public resetPassForm: FormGroup;
  public submitted: boolean = false; 
  public roles = [
    { name: 'Superadmin', value: 1 },
    { name: 'Admin', value: 2 },
    { name: 'Publisher', value: 3 }
  ];

  get f() { return this.resetPassForm.controls; }

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private toastService: ToastService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.resetPassForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]],
      // roleId: ['', Validators.required]
    });
  }

  /**
 * Verifies the email address for password reset.
 * Sends a request to the API to initiate the password reset process for the provided email address.
 * Displays success or error message based on the API response.
 */
  verifyEmail() {
    this.submitted = true;
    if (this.resetPassForm.invalid) {
      return;
    }
    let email = this.resetPassForm.value.email;
    // let roleId = this.resetPassForm.value.roleId;
    let dataObj = {
      "email": email,
      "roleId" : 1
    }
    this.apiService.postAPIV3('/user/forgot-password', dataObj).subscribe(res => {
      if (res['statusCode'] == 200) {
        this.toastService.showSuccess(res['message'], 'Success');
        this.router.navigateByUrl('/')
      }
      else {
        this.toastService.showError(res['message'], 'Error')
      }
    });
  }
}